import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoanschemeService } from "../shared/loanscheme.service";

@Component({
  selector: 'app-loanscheme',
  templateUrl: './loanscheme.component.html',
  styleUrls: ['./loanscheme.component.css']
})
export class LoanschemeComponent implements OnInit {

  AddButtonText: string;
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  divDetails: boolean;
  ParentSchemeNo: number;
  LoanTypeList: [''];
  LoanCategoryList:[''];
  PeriodTypeList:[''];

  constructor(private router: Router, private activatedRoute: ActivatedRoute, public loanschemeService: LoanschemeService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentSchemeNo = + param['Id'];  //Parent Group Id
    });

    this.divDetails = true;
 
    this.GetLoanCategoryList();
    this.GetLoanTypeList();
   this. GetPeriodTypeList();
  
    this.dataSourceList.paginator = this.paginator;
    this.resetForm();
    if (Number.isNaN(this.ParentSchemeNo)) {
      this.loanschemeService.selectedLoanScheme.Id = 0;
      this.loanschemeService.selectedLoanScheme.Flag = 1;
      this.loanschemeService.selectedLoanScheme.IsActive = 1;
      this.AddButtonText = "Save";
    }
    else {
      this.loanschemeService.selectedLoanScheme.Id = +this.ParentSchemeNo;
      this.loanschemeService.selectedLoanScheme.Flag = 2;
      this.AddButtonText = "Edit & Save";

      this.GetLedgerById();
    }
    
      
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.loanschemeService.selectedLoanScheme = {
      Id: 0,
      SchemeName: null,
      SchemeCode: null,
      LoanTypeId: 1,
      LoanCategoryId: 0,
      MinValue: null,
      MaxValue: null,
      LoanPeriod: null,
      PeriodTypeId: 0,
      ExpiryPeriod: null,
      InterestPrecentage: null,
      DelayInterest: null,
      FlatInterest: null,
      MinimumInterestAmount: null,
      MinimumCloseAmount: null,
      EMITypeId: null,
      InstallmentAmount: null,
      InstallmentBaseAmount: null,
      InstallmentPremiumAmount: null,
      CalculationMethodId: null,
      DefaultFee: null,
      AdvanceEMI: null,
      GracePeriod: null,
      CompanyId: null,
      EmployeeBranchId: null,
      EmployeeId: null,
      SaasId: null,
      IsActive: 0,
      Flag: 0,
    }
  }

  public onSubmit(form: NgForm) {
    this.loanschemeService.IUDLoanScheme(form.value)
      .toPromise()
      .then(data => {
        this.resetForm(form);
        this.router.navigate(['/loanschemelist']);
      })
      .catch(err => { console.log(err) });
  }

  GetLedgerById() {

    if (!Number.isNaN(this.ParentSchemeNo)) {
      this.loanschemeService.selectedLoanScheme.Id = this.ParentSchemeNo;
      this.loanschemeService.FetchLoanSchemeById(this.loanschemeService.selectedLoanScheme).subscribe(data => {
        this.loanschemeService.selectedLoanScheme = data;
        this.loanschemeService.selectedLoanScheme.Flag = 2;

        console.log(data);
      })
    }
  }

  GetLoanTypeList() {
    this.loanschemeService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetLoanCategoryList() {
    this.loanschemeService.FetchLoanCategory().subscribe(data => {
      this.LoanCategoryList = data;
    })
  }

  GetPeriodTypeList() {
    this.loanschemeService.FetchPeriodType().subscribe(data => {
      this.PeriodTypeList = data;
    })
  }
  

}
